import React, { useMemo } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../../_metronic/_partials/controls";
import { ObjectsFilter } from "./objects-filter/ObjectsFilter";
import { ObjectsTable } from "./objects-table/ObjectsTable";
import { ObjectsGrouping } from "./objects-grouping/ObjectsGrouping";
import { useObjectsUIContext } from "./ObjectsUIContext";
import { useIntl } from "react-intl";
import { useFilterObjectsUIContext } from "./FilterObjectsUIContext";
import { ReportFilter } from "./objects-filter/ReportFilter";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../../../../../src/app/actions/generalActions";
import { ShowToast, ToastType } from "../../../../_helpers/ToastHelpers";

export function ObjectsCard({
  hideSelected = false,
  checkActive = false,
  showAuditResultForm = false,
  haveChangePasswordAction = false,
  haveStimulsoftReport = false,
  rowFormatter,
  getFunctionName,
  AuditAction,
  filterByShowButton = false,
  haveGeneralAction = true,
  groupSettingAction = false,
  isFullAccess,
  api,
  basePath,
  columns,
  currentState,
  prepareFilter,
  filterFields,
  filterInitialValues,
  parentId,
  prentName,
  haveSaveAllButton,
  haveExportButton = false,
  exportfuncName,
  enablePagination = true,
  detailColumns,
  setParentData,
  setDetailData,
  mrtUrl,
  jsonFileName
}) {
  const ObjectsUIContext = useObjectsUIContext();
  const filterUIContext = useFilterObjectsUIContext();

  const { placeAuditFormListState, isLoading, sliceName } = useSelector(
    (state) => ({
      isLoading: state.placeAuditFormList.actionsLoading,
      placeAuditFormListState: state.placeAuditFormList.entities,
      sliceName: state.placeAuditFormList.name,
    }),
    shallowEqual
  );

  const intl = useIntl();
  const ObjectsUIProps = useMemo(() => {
    return {
      ids: ObjectsUIContext.ids,
      queryParams: filterUIContext.queryParams,
      setQueryParams: filterUIContext.setQueryParams,
      newObjectButtonClick: ObjectsUIContext.newObjectButtonClick,
      openDeleteObjectsDialog: ObjectsUIContext.openDeleteObjectsDialog,
      openHardDeleteObjectsDialog: ObjectsUIContext.openHardDeleteObjectsDialog,
      openChangePassObjectsDialog: ObjectsUIContext.openChangePassObjectsDialog,
      openRefreshObjectDialog: ObjectsUIContext.openRefreshObjectDialog,
      openEditObjectPage: ObjectsUIContext.openEditObjectPage,
      openFloorsPage: ObjectsUIContext.openFloorsPage,
      openRoomsPage: ObjectsUIContext.openRoomsPage,
      openAttendenceSettingPage: ObjectsUIContext.openAttendenceSettingPage,
      openCullinanSettingPage: ObjectsUIContext.openCullinanSettingPage,
      openDormSettingPage: ObjectsUIContext.openDormSettingPage,
      openSportSettingPage: ObjectsUIContext.openSportSettingPage,
      openUpdateObjectsStatusDialog:
        ObjectsUIContext.openUpdateObjectsStatusDialog,
      openFetchObjectsDialog: ObjectsUIContext.openFetchObjectsDialog,
      openAuditOptionDialog: ObjectsUIContext.openAuditOptionDialog,
    };
  }, [ObjectsUIContext, filterUIContext]);

  const dispatch = useDispatch();
  const createAuditFormListClick = () => {
    dispatch(
      actions.createObjectWithoutResult(
        "api/AuditFormResult",
        sliceName,
        {},
        "CreateAuditFormResultAndList"
      )
    ).then(() => {
      // ShowToast("پرسشنامه های مراکزی که شما به آنها دسترسی دارید با موفقیت ایجاد شد.", ToastType.success)
      dispatch(
        actions.fetchObjects(
          api,
          sliceName,
          ObjectsUIProps.queryParams,
          getFunctionName
        )
      );
    });
  };

  const handleClickExport = () => {
    dispatch(
      actions.downloadExcelFile(
        api,
        currentState.name,
        ObjectsUIProps.queryParams,
        exportfuncName
      )
    );
  };
  return (
    <Card>
      {enablePagination && (
        <CardHeader title={haveSaveAllButton ? null : ""}>
          {haveSaveAllButton &&
            (ObjectsUIProps.queryParams.filter.title === undefined ||
              ObjectsUIProps.queryParams.filter.title === "") &&
            (ObjectsUIProps.queryParams.filter.provinceId === undefined ||
              ObjectsUIProps.queryParams.filter.provinceId === 0) &&
            placeAuditFormListState &&
            placeAuditFormListState.length === 0 && (
              <div className="text-info mt-7">
                با زدن دکمه ایجاد پرسشنامه ها، پرسشنامه های مورد نظر برای شما
                ایجاد می شود <br />و نیاز است  مجدد وارد سامانه شوید
              </div>

            )}
          {haveSaveAllButton &&
            (ObjectsUIProps.queryParams.filter.title === undefined ||
              ObjectsUIProps.queryParams.filter.title === "") &&
            (ObjectsUIProps.queryParams.filter.provinceId === undefined ||
              ObjectsUIProps.queryParams.filter.provinceId === 0) &&
            placeAuditFormListState &&
            placeAuditFormListState.length === 0 && (
              <div className="text-warning mt-3">
                توجه داشته باشید که پس از تکمیل املاک مورد نظر خود این گزینه را
                . کلیک نمایید. در غیر اینصورت پرسشنامه شما ناقص خواهد بود.
              </div>
            )}
          <CardHeaderToolbar>
            {haveGeneralAction && (
              <button
                type="button"
                className="btn btn-primary"
                onClick={ObjectsUIProps.newObjectButtonClick}
                disabled={!isFullAccess}
              >
                {intl.formatMessage({ id: "MODULES.GENERAL.BUTTONNEW" })}
              </button>
            )}
            {haveSaveAllButton &&
              (ObjectsUIProps.queryParams.filter.title === undefined ||
                ObjectsUIProps.queryParams.filter.title === "") &&
              (ObjectsUIProps.queryParams.filter.provinceId === undefined ||
                ObjectsUIProps.queryParams.filter.provinceId === 0) &&
              placeAuditFormListState &&
              placeAuditFormListState.length === 0 && (
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={createAuditFormListClick}
                  disabled={!isFullAccess}
                >
                  <span>
                    {"   "}
                    {"ایجاد پرسشنامه ها"}
                    {"   "}
                  </span>

                  {isLoading && (
                    <span className="ml-3 spinner spinner-white"></span>
                  )}
                </button>
              )}

            {haveExportButton && (
              <button
                type="button"
                className="btn btn-info"
                onClick={handleClickExport}
              // disabled={!isFullAccess}
              >
                <span>
                  {"   "}
                  {"دانلود گزارش"}
                  {"   "}
                </span>

                {currentState.actionsLoading && (
                  <span className="ml-3 spinner spinner-white"></span>
                )}
              </button>
            )}
          </CardHeaderToolbar>
        </CardHeader>
      )}
      {!enablePagination && (
        <CardHeader title="">
          {haveSaveAllButton &&
            (ObjectsUIProps.queryParams.filter.title === undefined ||
              ObjectsUIProps.queryParams.filter.title === "") &&
            (ObjectsUIProps.queryParams.filter.provinceId === undefined ||
              ObjectsUIProps.queryParams.filter.provinceId === 0) &&
            placeAuditFormListState &&
            placeAuditFormListState.length === 0 && (
              <div className="text-info mt-7">
                با زدن دکمه ایجاد پرسشنامه ها، پرسشنامه های مورد نظر برای شما
                ایجاد میشود
              </div>
            )}
          {haveSaveAllButton &&
            (ObjectsUIProps.queryParams.filter.title === undefined ||
              ObjectsUIProps.queryParams.filter.title === "") &&
            (ObjectsUIProps.queryParams.filter.provinceId === undefined ||
              ObjectsUIProps.queryParams.filter.provinceId === 0) &&
            placeAuditFormListState &&
            placeAuditFormListState.length === 0 && (
              <div className="text-warning mt-3">
                توجه داشته باشید که پس از تکمیل املاک مورد نظر خود این گزینه را
                کلیک نمایید. در غیر اینصورت پرسشنامه شما ناقص خواهد بود.
              </div>
            )}
          <CardHeaderToolbar>
            {haveExportButton && (
              <button
                type="button"
                className="btn btn-info"
                onClick={handleClickExport}
              // disabled={!isFullAccess}
              >
                <span>
                  {"   "}
                  {"دانلود گزارش"}
                  {"   "}
                </span>

                {currentState.actionsLoading && (
                  <span className="ml-3 spinner spinner-white"></span>
                )}
              </button>
            )}
          </CardHeaderToolbar>
        </CardHeader>
      )}

      <CardBody>
        {!filterByShowButton && (
          <ObjectsFilter
            prepareFilter={prepareFilter}
            filterFields={filterFields}
            filterInitialValues={filterInitialValues}
          />
        )}
        {filterByShowButton && (
          <ReportFilter
            prepareFilter={prepareFilter}
            filterFields={filterFields}
            filterInitialValues={filterInitialValues}
          />
        )}
        {ObjectsUIProps.ids.length > 0 && (
          <>
            <ObjectsGrouping
              haveChangePasswordAction={haveChangePasswordAction}
              haveGeneralAction={haveGeneralAction}
              groupSettingAction={groupSettingAction}
              isFullAccess={isFullAccess}
            />
          </>
        )}

        <ObjectsTable
          showAuditResultForm={showAuditResultForm}
          rowFormatter={rowFormatter}
          checkActive={checkActive}
          hideSelected={hideSelected}
          getFunctionName={getFunctionName}
          filterByShowButton={filterByShowButton}
          AuditAction={AuditAction}
          haveGeneralAction={haveGeneralAction}
          groupSettingAction={groupSettingAction}
          isFullAccess={isFullAccess}
          api={api}
          basePath={basePath}
          currentState={currentState}
          columns={columns}
          parentId={parentId}
          prentName={prentName}
          enablePagination={enablePagination}
          detailColumns={detailColumns}
          setParentData={setParentData}
          setDetailData={setDetailData}
          haveStimulsoftReport={haveStimulsoftReport}
          mrtUrl={mrtUrl}
          jsonFileName={jsonFileName}
        />
      </CardBody>
    </Card>
  );
}
